<template>
  <right-panel :datas="accountInfo" ref="rightPanel" @onClose="onClose">
    <div slot="header">
      <translate>Bind MFA</translate>
    </div>
    <div slot="content">
      <div class="detail-wrapper" v-show="!mfa.nextStep">
        <!--<div class="detail-desc">-->
          <!--<translate>Note: If you need to manage the windows machine, do not open MFA, windows RDP client does not support MFA.</translate>-->
        <!--</div>-->
        <div class="detail-desc">
          <translate>1. You must install the MFA application on your smart device to continue.</translate>
        </div>
        <div class="detail-desc">
          <translate>2. Common applications that support MFA on smart devices are </translate><a style="color: #20a0ff;" href="https://promotion.aliyun.com/ntms/mobile.html" target="view_window"><translate>Identity</translate></a>, Microsoft Authenticator，Google Authenticator.
        </div>
        <div class="detail-desc">
          <translate>3. If your account has been shared by multiple people, then when you successfully bind MFA, other unbound MFA people will not be able to log in. The solution is to let other people also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to follow the sweep. But from the security best practice, we recommend that you cancel the multiplayer account.</translate>
        </div>
        <div class="detail-desc">
          <translate>4. If you can not verify for some reason, such as missing or mistakenly deleted MFA applications, you can manually unmarshal MFA binding by dialing 021-50653160.</translate>
        </div>
      </div>
      <div class="detail-wrapper" v-show="mfa.nextStep && mfa.securityNumForm.mfaEwm !== ''">
        <el-tabs :active-name="mfa.activeTab" @tab-click="onTabClick">
          <el-tab-pane name="first">
            <span slot="label"><translate>Scan the two-dimensional code</translate></span>
            <div class="scan-ewm">
              <img :src='mfa.securityNumForm.mfaEwm' alt="">
              <p><translate>Please use the MFA application on your smartphone to scan</translate></p>
            </div>
          </el-tab-pane>
          <el-tab-pane name="second">
            <span slot="label"><translate>Manual input</translate></span>
            <div class="hand-get">
              <p><translate>Authentication information</translate></p>
              <p><translate>user name</translate>: {{mfa.secret.account}}</p>
              <p><translate>Key</translate>: {{mfa.secret.secret}}</p>
              <p><translate>Please enter the above information manually in the MFA application to obtain the security code</translate></p>
            </div>
          </el-tab-pane>
          <div class="securityNum">
            <p class="tip-text"><translate>Please enter the two consecutive security codes you have obtained from the MFA application</translate>:</p>
            <el-form :model="mfa.securityNumForm" :rules="rules" ref="securityNumForm" label-position="top" class="demo-ruleForm">
              <el-form-item :label="attrText.firstCode" prop="firstCode">
                <el-input class="input-class" v-model="mfa.securityNumForm.firstCode" :placeholder="attrText.enterCode"></el-input>
              </el-form-item>
              <el-form-item :label="attrText.secondCode" prop="secondCode">
                <el-input class="input-class" v-model="mfa.securityNumForm.secondCode" :placeholder="attrText.enterCode"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-tabs>
      </div>
    </div>
    <div slot="footer" class="detail-btn">
      <div class="btn-wrapper" v-if="!mfa.nextStep">
        <el-button type="primary" @click="onNextStep()">
          <translate>Next</translate>
        </el-button>
        <el-button @click="$refs.rightPanel.onClose()">
          <translate>Cancel</translate>
        </el-button>
      </div>
      <div class="btn-wrapper" v-if="mfa.nextStep">
        <el-button type="primary" @click="submitMfaString('securityNumForm')">
          <translate>Save</translate>
        </el-button>
        <el-button @click="$refs.rightPanel.onClose()">
          <translate>Cancel</translate>
        </el-button>
      </div>
    </div>
  </right-panel>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import { baseUrl } from '../../../config'
  import RightPanel from '../../common/right-panel'
  export default{
    name: 'AccountMfaOpen',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        accountInfo: null,
        mfa: {
          nextStep: false,
          activeTab: 'first',
          securityNumForm: {
            mfaEwm: '',
            firstCode: '',
            secondCode: ''
          },
          secret: {}
        },
        rules: {
          firstCode: [
            {required: true, pattern: /^\d{6}$/, message: this.$gettext('Enter the 6-digit security code'), trigger: 'blur'}
          ],
          secondCode: [
            {required: true, pattern: /^\d{6}$/, message: this.$gettext('Enter the 6-digit security code'), trigger: 'blur'}
          ]
        }
      }
    },
    computed: {
      attrText () {
        return this.getTranslateText()
      }
    },
    methods: {
      getTranslateText () {
        return {
          'firstCode': this.$gettext('First column verification code'),
          'secondCode': this.$gettext('Second column verification code'),
          'enterCode': this.$gettext('Enter the 6-digit security code')
        }
      },
      onNextStep () {
        this.resetForm('securityNumForm')
        // ewm img
        this.mfa.secret = ''
        this.mfa.securityNumForm.mfaEwm = baseUrl.apiUrl + '/mfa/img?t=' + new Date().getTime()
        console.log('mfaEwm==>', this.mfa.securityNumForm.mfaEwm)
        this.mfa.activeTab = 'first'
        this.mfa.nextStep = true
      },
      onTabClick (v) {
        this.mfa.activeTab = v.name
        if (this.mfa.activeTab === 'second' && !this.mfa.secret) {
          // get mfa secret code
          this.$store.dispatch(STORE_CONST.ACCOUNT.GET_MFA_SECRET).then(res => {
            this.mfa.secret = res
          })
        }
        this.resetForm('securityNumForm')
      },
      // submit mfa string, open mfa
      submitMfaString (formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = {
              data: {
                first_code: this.mfa.securityNumForm.firstCode,
                second_code: this.mfa.securityNumForm.secondCode,
                otp_enabled: 1
              }
            }
            this.$store.dispatch(STORE_CONST.ACCOUNT.POST_MFA_CODE, params).then(res => {
              this.$notify({
                type: 'success',
                message: this.$gettext('Open success!')
              })
              this.$emit('callback', this.$store.getters.account.id)
              this.$refs.rightPanel.onClose()
            })
          } else {
            return false
          }
        })
      },
      // reset form
      resetForm (formName) {
        this.$refs[formName].resetFields()
      },
      // 关闭侧滑
      onClose () {
        this.accountInfo = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.accountInfo) {
            this.accountInfo = null
            setTimeout(() => {
              this.accountInfo = this.items
            }, 300)
          } else {
            this.accountInfo = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  .detail-desc{
    padding: 0 30px;
    margin-top: 20px;
  }
  .detail-wrapper {
    .securityNum{
      margin-top: 40px;
      .el-form-item {
        .el-form-item__label {
          &:before {
            content: '*';
          }
        }
      }
      .tip-text{
        margin-bottom: 10px;
      }
    }
    .el-tabs__header{
      padding: 0;
      margin-bottom: 0;
      .el-tabs__item{
        height: 25px;
        line-height: 25px;
      }
    }
    .el-tabs__active-bar{
      height: 2px;
    }
  }
  .hand-get{
    padding-left: 45px;
    margin-top: 40px;
    margin-bottom: 10px;
    p{
      margin-bottom: 10px;
      &:last-child{
        margin-bottom: 0;
        font-weight: 700;
      }
    }
  }
  .scan-ewm{
    text-align: center;
    margin-top: 15px;
    img{
      width: 50%;
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// account-open-mfa.vue?4ea3c656